import AttachmentsContainer from "src/reusable/Chat/PromptInput/AttachmentsContainer";
import {
  useRemoveWorkflowInputFile,
  useWorkflowInputFilesDisplay,
} from "../hooks/useWorkflowInputFilesDisplay";
import type { WorkflowRunStoreHandle } from "../store/createWorkflowRunStore";

/**
 * Uploaded/selected input documents for a workflow run, rendered on the
 * platform's standard attachment rows (AttachmentsContainer) with remove
 * support. The mapping/removal logic is shared with proposal generation's
 * RFPViewer through useWorkflowInputFilesDisplay, so every workflow product
 * shows its staged files the same way.
 */
const WorkflowInputFilesViewer = ({
  store,
}: {
  store: WorkflowRunStoreHandle;
}) => {
  // Field selector, not the whole store: dialogue precreation and artifact
  // picks churn other fields and must not re-render the attachment rows.
  const inputFiles = store((s) => s.inputFiles);
  const { displayFiles, pendingArtifactFileIds, uploadError } =
    useWorkflowInputFilesDisplay(inputFiles);
  const removeFile = useRemoveWorkflowInputFile(store.getState);

  if (displayFiles.length === 0) {
    return null;
  }

  return (
    <AttachmentsContainer
      processedFiles={displayFiles}
      removeFile={removeFile}
      isDragActive={false}
      uploadError={uploadError}
      pendingArtifactFileIds={pendingArtifactFileIds}
    />
  );
};

export default WorkflowInputFilesViewer;
